<template>
    <div>
        <div v-if="useSelectList">
            <template v-if="!variables">
                <div v-if="isDevelopment">Variables are not defined</div>
            </template>
            <select
                v-else
                :id="listId"
                size="8"
                class="form-control select-item-2"
                style="height: 150px; width: 100%"
                v-model="theSelectedValue"
                :disabled="variables.length === 0 || !isEnabled"
                v-on:change="selectListValueChanged"
            >
                <option
                    v-for="variable in variables.filter((v) => shouldShow(v))"
                    v-bind:value="variable.variable"
                    v-bind:key="variable.variable"
                >
                    {{ displayFormatter2(variable) }}
                </option>
            </select>
        </div>
        <div v-if="!useSelectList" class="pre-scrollable form-control">
            <div
                v-for="variable in variables.filter((v) => shouldShow(v))"
                v-bind:key="variable.variable + '_|_2'"
                class="select-item"
            >
                <label>
                    <input
                        name="variableList"
                        type="radio"
                        v-bind:value="variable.variable"
                        v-model="theSelectedValue"
                        v-on:change="selectedValueChanged($event, variable)"
                    />
                    {{ displayFormatter2(variable) }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off', no-control-regex: 'off' */
import variableSelectionHelper from '@/scripts/variableSelectionHelper';

//4:08pm

export default {
    // model: {
    //     isEnabled: 'true'
    // },
    props: [
        'bind',
        'startingSelectedValue',
        'showGroup',
        'searchText',
        'isEnabled',
        'listId'
    ],
    computed: {
        isDevelopment: {
            get: () => process.env.NODE_ENV === 'development'
        }
        //     theSelectedValue: {
        //         get: function () {
        //             return this.value;
        //         },
        //         // setter
        //         set: function (newValue) {
        //             this.$emit('input', newValue);
        //         }
        //     }
    },
    watch: {
        bind(updatedVariables) {
            const vm = this;
            vm.variables = updatedVariables;
            vm.theSelectedValue = null;
            vm.$emit('variableIsSelected', null);
        }
    },
    created: function () {
        const vm = this;
        vm.theSelectedValue = vm.startingSelectedValue;
    },
    data: function () {
        return {
            variables: this.bind,
            useSelectList: true,
            variableSelectionHelper: variableSelectionHelper,
            searchRegex: null,
            searchRegexSource: this.searchText,
            filter: false,
            theSelectedValue: null
        };
    },
    methods: {
        selectListValueChanged,
        selectedValueChanged,
        escapeRegExp: function (s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        shouldShow: function (variable) {
            if (this.searchRegexSource !== this.searchText) {
                this.searchRegexSource = this.searchText;
                //var beginning = /\\^/;
                //var ending = /.+/;
                var beginning = '^';
                var ending = '.+';
                var wordBeginning = '(?=.*';
                var wordEnding = ')';

                var words = this.searchRegexSource
                    .split(/[ ,//]+/)
                    .filter((s) => s.length > 0);
                //regexString = beginning +
                var fullString =
                    beginning +
                    words.map((s) => wordBeginning + s + wordEnding).join('') +
                    ending;
                this.searchRegex = new RegExp(fullString, 'i');
                //this.searchRegex = new RegExp('^(?=.*' + this.searchRegexSource + ').+', 'i');
                //match whole word
                //this.searchRegex = new RegExp('^(?=.*\\b' + this.searchRegexSource + '\\b).+', 'i');

                //this.searchRegex = new RegExp('^(?=.*\\bactivity\\b).+', 'i');
                //this.searchRegex = new RegExp(/^(?=.*\bactivity\b).+/, 'i');
                //this.searchRegex = new RegExp(this.escapeRegExp(this.searchRegexSource), 'i');
                //this.searchRegex = new RegExp(this.escapeRegExp(this.searchRegexSource), 'i');
                this.filter =
                    this.searchText !== undefined && this.searchText !== '';
            }
            var variableTitle =
                variable.groupTitle + ': ' + variable.variableTitle;
            return !this.filter || variableTitle.search(this.searchRegex) >= 0; //variable.variableTitle.indexOf(this.searchText) !== -1;
        },
        displayFormatter2: function (variable) {
            return (
                variable.variableTitle +
                (this.showGroup ? ' (' + variable.groupTitle + ')' : '')
            );
        }
    }
};

function selectListValueChanged(e) {
    const vm = this;
    vm.$emit('variableIsSelected', vm.theSelectedValue);
}

function selectedValueChanged(e, variable) {
    const vm = this;
    vm.$emit('variableIsSelected', vm.theSelectedValue);
}
</script>

<style scoped>
/*input[type="radio"] {
    visibility: hidden;
  }

    input[type="radio"]:checked {
      visibility: hidden;
    }*/

/*input[type="radio"]:checked {
      background-color: grey;
      color: -internal-inactive-list-box-selection-text;
    }*/

label:has(> input[type='radio']:checked) {
    background-color: #bbb;
}
input[type='radio'] + label {
    /*background-color: grey;*/
    font-weight: 400;
    padding: 0px 2px 1px 2px;
    margin: 0 0 0 0;
    line-height: 1.42857143;
}
input[type='radio']:checked + label {
    background-color: #bbb;
    /*background-color: grey;*/
    color: -internal-inactive-list-box-selection-text;
}
.pre-scrollable {
    height: 200px;
}
.select-item {
    margin: 3px 0 0 0;
}
.select-item input {
    margin: 0 0 0 0;
}
.select-item input[type='radio'] {
    /*visibility: hidden;*/
    display: none;
}

select.select-item-2 {
    /*width: 200px;*/
    max-width: 100%; /* So it doesn't overflow from it's parent */
}

select.select-item-2 option {
    /* wrap text in compatible browsers */
    -moz-white-space: pre-wrap;
    -o-white-space: pre-wrap;
    white-space: pre-wrap;
    /* hide text that can't wrap with an ellipsis */
    overflow: hidden;
    text-overflow: ellipsis;
    /* add border after every option */
    /*border-bottom: 1px solid #DDD;*/
}
</style>
